import { SphereAppCategory } from '@app/app-routes';
import { createFeature, createReducer, on } from '@ngrx/store';
import { AppSwitcherActions } from '@app/portal/app-switcher/+state/app-switcher.actions';

export type AppSwitcherState = {
    selectedCategory: SphereAppCategory | 'favorites';
};

const initialState: AppSwitcherState = {
    selectedCategory: null
};

const reducer = createReducer<AppSwitcherState>(
    initialState,
    on(AppSwitcherActions.selectAppCategory, (state, props) => {
        return {
            ...state,
            selectedCategory: props.appCategory
        };
    })
);

export const appSwitcherFeature = createFeature({ name: 'appSwitcherFeature', reducer });
